import Service from "../../services";

const state = {};

const getters = {};

const actions = {
  save({ commit }, data) {
    return Service.tender.save(data).then((res) => {
      return res;
    });
  },
  update({ commit }, data) {
    return Service.tender.update(data).then((res) => {
      return res;
    });
  },
  delete({ commit }, id) {
    return Service.tender.delete(id).then((res) => {
      return res;
    });
  },
  resendMail({ commit }, id) {
    return Service.tender.resendMail(id).then((res) => {
      return res;
    });
  },
  duplicate({ commit }, id) {
    return Service.tender.duplicate(id).then((res) => {
      return res;
    });
  },
  print({ commit }, data) {
    return Service.tender.print(data).then((res) => {
      return res;
    });
  },
  getData({ commit }, mode) {
    return Service.tender.getData(mode).then((res) => {
      return res;
    });
  },
  getDataChart({ commit }) {
    return Service.tender.getDataChart().then((res) => {
      return res;
    });
  },
  getDataById({ commit }, id) {
    return Service.tender.getDataById(id).then((res) => {
      return res;
    });
  },
  search({ commit }, data) {
    return Service.tender.search(data).then((res) => {
      return res;
    });
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
